import { render, staticRenderFns } from "./MarketplaceCardSlider.vue?vue&type=template&id=2b649fe8&scoped=true"
import script from "./MarketplaceCardSlider.vue?vue&type=script&lang=js"
export * from "./MarketplaceCardSlider.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceCardSlider.vue?vue&type=style&index=0&id=2b649fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b649fe8",
  null
  
)

export default component.exports